export type ReportTemplateAssignmentPayload = {
  report_template_id: number;
  list_order: number;
  is_required: boolean;
  required_at: string | null;
};

export type AttachedReportTemplate = ReportTemplateAssignmentPayload & {
  report_template_name?: string;
  description?: string | null;
};

export type AssignReportTemplatesScope = 'CHURCH' | 'DISTRICT' | 'NATION';

export type SyncReportTemplatesOptions = {
  confirmClearAll?: boolean;
};

export const ASSIGN_REPORT_TEMPLATES_SCOPE_LABEL: Record<AssignReportTemplatesScope, string> = {
  CHURCH: 'church',
  DISTRICT: 'district',
  NATION: 'nation',
};
